import {ApiClient, BrowserBackendSelector, getDefaultDFBackends} from '@hconnect/apiclient'

/**
 * Redirects all Settings API requests to the HProduce domain.
 *
 * The apiclient's built-in baseUrl interceptor sets `baseURL` to the legacy
 * hconnect host on every request. We register an interceptor that runs after it
 * and simply overwrites `baseURL` with the equivalent hproduce host.
 *
 * Does nothing on local/dev environments (no mapping exists).
 */

const HPRODUCE_DOMAIN: Readonly<Record<string, string>> = {
  'https://api-qa.hconnect.heidelbergcement.com': 'https://api-qa.hproduce.digital',
  'https://api-uat.hconnect.heidelbergcement.com': 'https://api-uat.hproduce.digital',
  'https://api.hconnect.heidelbergcement.com': 'https://api.hproduce.digital'
}

let isRegistered = false

export function registerDomainOverride(): void {
  if (isRegistered) return
  isRegistered = true

  if ((window as any).Cypress) return

  const apiUrl = new BrowserBackendSelector(getDefaultDFBackends()).getSelectedBackend().API_URL
  const hproduceUrl = HPRODUCE_DOMAIN[apiUrl]
  if (!hproduceUrl) return

  ApiClient.axiosInstance.interceptors.request.use((config) => {
    if (!config.url) return config
    let path = config.url
    if (path.startsWith('http')) {
      const parsed = new URL(path)
      path = parsed.pathname + parsed.search
    }
    return {...config, url: new URL(path, hproduceUrl).toString(), baseURL: undefined}
  })
}
